import { createContext, useContext } from "react";
import type { ToolConfirmationDecision } from "@/api";

export interface ProposalContextValue {
  /** Someone the chat was shared with: cards are read-only. */
  readOnly: boolean;
  /** A reply is on its way: cards wait for it before acting. */
  busy: boolean;
  /** Sends my next message (a decision's text is the button's label; a card's choice, e.g. a picked time, has no
   *  decision); `onFailed` when it isn't sent. */
  onDecide?: (content: string, confirmation: ToolConfirmationDecision | undefined, onFailed: () => void) => void;
}

const ProposalContext = createContext<ProposalContextValue>({ readOnly: true, busy: false });

export const ProposalProvider = ProposalContext.Provider;
export const useProposalContext = () => useContext(ProposalContext);
